import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TcPage } from '@tc/core';
import { IPageState } from '@tc/store';

@Component({
  selector: 'app-interactions-page',
  templateUrl: './interactions-page.component.html',
  styleUrls: ['./interactions-page.component.scss'],
})
export class InteractionsPageComponent extends TcPage implements OnInit {
  constructor(store: Store<any>) {
    super(store);
  }

  ngOnInit() {
    const pageInfo: IPageState = {
      title: 'interactions-page.title',
    };

    this.pageInfo = pageInfo;

    super.ngOnInit();
  }
}
